import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, profile, loading, isSubscribed } = useAuth();
  const location = useLocation();
  const [profileTimeout, setProfileTimeout] = useState(false);

  // If user exists but profile never arrives after 5 seconds, escape the spinner
  useEffect(() => {
    if (!loading && user && !profile) {
      const timer = setTimeout(() => setProfileTimeout(true), 5000);
      return () => clearTimeout(timer);
    }
  }, [loading, user, profile]);

  // 1. Still loading session or profile fetch in progress
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-[#2C2C2C] border-t-[#C9922A] rounded-full animate-spin" />
      </div>
    );
  }

  // 2. No user — send to login
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // 3. User exists but profile still loading — wait, but not forever
  if (user && !profile && !profileTimeout) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-[#2C2C2C] border-t-[#C9922A] rounded-full animate-spin" />
      </div>
    );
  }

  // 4. Profile never arrived — send to pricing
  if (user && !profile && profileTimeout) {
    return <Navigate to="/pricing" replace />;
  }

  // 5. User and profile loaded — check subscription
  if (!isSubscribed()) {
    return <Navigate to="/pricing" replace />;
  }

  // 6. All clear
  return children;
}
